import $ from 'jquery';
import stickybits from 'stickybits';


/* Page load auto achor scroll
********************************************/

$(document).ready(function() {
	var anchor = window.location.hash;
	if (anchor) {
		var blocks = $('[name="' + anchor.substr(1) + '"]');
		if ( blocks.length > 0 ) {
			$([document.documentElement, document.body]).animate({
				scrollTop: $(blocks[0]).offset().top
			}, 500);
		}
	}
});

/* Page navigation click events
********************************************/

if ($('.js-page-nav-list').length) {
	$('.js-page-nav-list a').on('click', function (e) {
		e.preventDefault();
		$(this).parent().siblings().removeClass('is-selected');
		$(this).parent().addClass('is-selected');
	});
}


/* Sticky page navigation
********************************************/

if ($('.js-sticky-page-nav').length) {
	stickybits( '.js-sticky-page-nav', {
		useStickyClasses: true,
		//useFixed: true,
		//stickyBitStickyOffset: - pageHeaderHeight - 20,
		//customStickyChangeNumber: 10
	});
}


/* Page nav scroll events
********************************************/

if ($('.js-sticky-page-nav').length) {
/*
	var sections = $('.c-page > .c-block')
		, nav = $('.js-sticky-page-nav .js-page-nav-list')
		, nav_height = $( '.js-sticky-page-nav' ).outerHeight( true )
		, debounce_timer;

	$(window).on('scroll', function () {
		var cur_pos = $(this).scrollTop();
		if(debounce_timer) {
            window.clearTimeout(debounce_timer);
        }
		debounce_timer = window.setTimeout(function() {
			sections.each(function () {
				var top = $(this).offset().top - nav_height,
					bottom = top + $(this).outerHeight();

				if (cur_pos >= top && cur_pos <= bottom) {
					nav.find('li').removeClass('is-selected');
					sections.removeClass('active');

					$(this).addClass('active');
					nav.find('a[href="#' + $(this).attr('name') + '"]').parent().addClass('is-selected');
				}
			});

			console.log('Fire');
		}, 50);
	});
*/
	var sections = $('.c-page > .c-block')
		, nav = $('.js-sticky-page-nav .js-page-nav-list')
		, nav_height = $( '.js-sticky-page-nav' ).outerHeight( true )
		, scrolling = false;

	$( window ).scroll( function() {
		scrolling = true;
	});
	setInterval( function() {
		if ( scrolling ) {
			scrolling = false;

			var cur_pos = $(this).scrollTop();
			sections.each(function () {
				var top = $(this).offset().top - nav_height,
				bottom = top + $(this).outerHeight();

				if (cur_pos >= top && cur_pos <= bottom) {
					nav.find('li').removeClass('is-selected');
					sections.removeClass('active');

					$(this).addClass('active');
					nav.find('a[href="#' + $(this).attr('name') + '"]').parent().addClass('is-selected');
				}
			});

		}
	}, 100 );
	
}
